// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__XffR2","logoAndLinks":"Footer_logoAndLinks__aAwf-","logoWrap":"Footer_logoWrap__SMA8o","links":"Footer_links__1NHWp","green":"Footer_green__qC2qO"};